import React, { useState, useRef, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { getListKiemKho, updateDataSearch } from "../../actions/KiemKho";
import { Headersubfull } from "../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { useSelector, useDispatch } from "react-redux";
import { TableKiemKho } from "./TableKiemKho";
import { BtnXuatDanhSach } from "components/KiemKho/ChucNang/XuatDanhSach/BtnXuatDanhSach";
import KiemKhoApi from "service/kiemKhoApi";
import { pushNotification } from "../../utils/notifications";
import LayoutV2 from "containers/LayoutV2";
export const KiemKho = () => {
  const dispatch = useDispatch();
  //phân quyền
  const initQuyenDanhSach = {
    kiemkho: false,
  };
  const listKiemKho = [];
  const [listDaKiemKho, setListKiemKho] = useState(listKiemKho);
  const listKiemKhoFull = useSelector((state) => state.listKiemKhoFull); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchKiemKho); //dataSearchTaiSan dinh nghia o rootreducer
  const [quyenDanhSach, setQuyenDanhSach] = useState(initQuyenDanhSach);
  const LayQuyenQuanLyDanhSach = () => {
    KiemKhoApi.phanquyenKiemKho().then((response) => {
      // console.log(response.data);
      setQuyenDanhSach({
        ...quyenDanhSach,
        kiemkho:
          response.data.kiemkho === null || response.data.kiemkho === undefined
            ? false
            : response.data.kiemkho,
      });
    });
  };

  const onChangeCode = (code) => {
    let tempArr = [...listDaKiemKho];
    tempArr.push(code);
    setListKiemKho(tempArr);
  };

  const onKiemKho = (code, isCheck) => {
    let tempArr = [...listDaKiemKho];
    if (isCheck) {
      tempArr.push(code);
    } else {
      tempArr = tempArr.filter((item) => item !== code);
    }
    setListKiemKho(tempArr);
  };

  const onLuuKiemKho = () => {
    KiemKhoApi.luuKiemKho1({ listDaKiemKho }).then((response) => {
      if (response.data.Error == 0) {
        dispatch(getListKiemKho(dataSearch));
        let tempArr = [];
        setListKiemKho(tempArr);
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      }
    });
  };

  useEffect(() => {
    document.title = "Kiểm kho | Phần mềm quản lý cầm đồ Morman";
    LayQuyenQuanLyDanhSach();
  }, []);

  return (
    <LayoutV2>
      {quyenDanhSach.kiemkho && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                           Kiểm kho
                          </h1>
                        </div>
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2">
                          <ul>
                            <li>
                              <BtnXuatDanhSach />
                            </li>
                            <li>
                              <a
                                href={() => false}
                                className="icon-bgnew color-print1"
                                onClick={onLuuKiemKho}
                              >
                                <PopoversBootrap
                                  contentText="Lưu"
                                  trigger={["hover", "focus"]}
                                  placement={"top"}
                                >
                                  <img src="/app-assets/images/logo-print-v2.png" />
                                </PopoversBootrap>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop
                      onChangeCode={onChangeCode}
                      onLuuKiemKho={onLuuKiemKho}
                      listDaKiemKho={listDaKiemKho}
                    />
                    <SearchBarMobile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableKiemKho listDaKiemKho={listDaKiemKho} onKiemKho={onKiemKho} />
        </div>
      )}
      {quyenDanhSach.kiemkho === false && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                           Kiểm kho
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
